import MicroModal from 'micromodal';
import anime from 'animejs';

export default
{
    init()
    {
        // JavaScript to be fired on all pages
        /* Get component classname and add it to body for routing */

        $('.js-component').each(function(i, obj)
        {
            var classList = $(obj).attr('class').split(/\s+/);
            $.each(classList, function(index, item)
            {
                if (item.indexOf('component-theme') == -1 && item.indexOf('-shade') == -1)
                {
                    if(!(item == 'js-component' || item == 'component'))
                    {
                        $('body').addClass(item);
                    }
                }
            });
        });

        var Ajax =
        {
            token: '',
            url: '/wp-content/themes/orkla-ohpc-1.1/resources/ajax.php',
            execute: function (payload, success, failure)
            {
                var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
                var processData = true;
                var cache = true;
                var async = payload.async === false ? false : true;

                if (payload.data instanceof FormData) {
                    // set config values
                    processData = false;
                    cache = false;
                    contentType = false;

                    payload.data.append('class', payload.class);
                    payload.data.append('method', payload.method);
                    // Can only store string-data so JSON-ify params
                    payload.data.append('json', JSON.stringify(payload.param));

                    // set data proper
                    payload = payload.data;
                } else
                    payload.token = Ajax.token;

                $.ajax({
                    type: 'POST',
                    url: Ajax.url,
                    contentType: contentType,
                    processData: processData,
                    cache: cache,
                    data: payload,
                    async: async,
                    success: function (data)
                    {
                        //console.log (data);
                        if (data.result === 'success')
                        {
                            if (success instanceof Function)
                                success(data);
                        } else {
                            if (failure instanceof Function)
                                failure(data);
                        }
                    },
                    error: function (jqXHR, status)
                    {
                        console.log('failure: ' + status);
                        console.log (jqXHR);
                    },
                });
            },
        };

        window.Ajax = Ajax;

        window.Ajax.do_search = function ( sTheJson, success, failure )
        {
            window.Ajax.execute ({ class: 'generate', method: 'do_search', param: sTheJson }, success, failure );
        };

        window.Ajax.archive = function ( sTheJson, success, failure )
        {
            console.log (sTheJson);
            window.Ajax.execute ({ class: 'generate', method: 'archive', param: sTheJson }, success, failure );
        };





    },
  /* eslint-disable */
  finalize()
  {
        // JavaScript to be fired on all pages, after page specific JS is fired

        window.vacanciesUpdated = false;
        var vacancyWatch = null;

        MicroModal.init();

        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();
        var iTheSelectWidth = $(window).width() - 40;

        // calculate a value for vh, because Apple plumb does not care that the overlapping/growing/shrinking
        // parts of mobile Safari's UI cocks up the vh calculation
        const setVh = () => {
          const vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
          $('body').css('--vh', `${vh}px`);
        };

        setVh();

        $(window).on('resize', function()
        {
            windowHeight = $(window).height();
            windowWidth = $(window).width();
            scrollTop = $(window).scrollTop();

            setVh();

        });

        $(window).on('scroll', function()
        {
            var newScrollTop = $(window).scrollTop();

            if (newScrollTop > scrollTop + navbarThreshold && scrollTop > iTheNavbarHeight)
            {
                $('.orkla-header').addClass('-hide');
            }
            else if (newScrollTop <= scrollTop)
            {
                $('.orkla-header').removeClass('-hide');
            }

            scrollTop = newScrollTop;
            // scrollTop = $(window).scrollTop();
        });


        $(document).on('click', '.archive-show-more', function()
        {
            var $oTheContainer = $(this).closest('.component.archive');
            var $oTheTrigger = $(this);
            let sThePostType = 'post';
            let iTheTermID = $oTheContainer.attr('data-term-id');
            let iTheCurrentPage = $(this).closest('.component.archive').attr('data-current-page');
            let iThePostsPerPage = $(this).closest('.component.archive').attr('data-posts-per-page');
            var iTheMaxPages = $(this).closest('.component.archive').attr('data-max-pages');

            window.isLoading = true;

            $oTheTrigger.addClass('-is-loading');

            let oTheParam = { catid: iTheTermID, paged: iTheCurrentPage, post_type: sThePostType, posts_per_page: iThePostsPerPage};

            console.log (oTheParam);

            window.Ajax.archive ( oTheParam ,
                function (data)
                {
                    $oTheContainer.find('.archive-wrapper').append(data.markup);
                    $oTheContainer.attr('data-current-page', data.paged );
                    $oTheTrigger.removeClass('-is-loading');
                    if (1*data.paged == 1*iTheMaxPages || 1*iTheMaxPages == 0)
                    {
                        $oTheTrigger.addClass('-is-hidden');
                    }
                    window.isLoading = false;

                    // do the reveal animation stuff
                    setupRevealItems({ block: '.component.archive', target: '.archive-item' });
                },
                function (data)
                {
                    window.isLoading = false;
                    $oTheTrigger.removeClass('-is-loading');
                }
            );
        });

        if (windowWidth <= 744)
        {
            $('.select-css').select2({
                minimumResultsForSearch: Infinity,
                width: (windowWidth - 40) + 'px',
            })
            .maximizeSelect2Height({
                cushion: 20 // Must be a numerical pixel value.
            });
        }
        else
        {
            $('.select-css').select2({
                minimumResultsForSearch: Infinity
            })
            .maximizeSelect2Height({
                cushion: 100 // Must be a numerical pixel value.
            });
        }


        window.oTheContainer = $('.search-result-container');
        window.oTheSearchForm = $('.main-menu-search');
        window.oTheTrigger = $('.search-button');
        window.sTheQuery = '';
        window.iTheTagID = '';
        window.iTheCatID = '';
        window.iTheMonth = '';
        window.iTheYear = '';
        window.iThePaged = 1;

        function loadPosts ()
        {
            window.sTheQuery = $('#headerSearchInput').val();
            window.iTheTagID = window.oTheTrigger.attr('data-tag-id');
            window.iTheCatID = window.oTheTrigger.attr('data-cat-id');
            window.iTheMonth = window.oTheTrigger.attr('data-month');
            window.iTheYear = window.oTheTrigger.attr('data-year');
            window.iThePaged = window.oTheTrigger.attr('data-paged');
            window.isLoading = true;

            let oTheParam = {
                query: window.sTheQuery,
                year: window.iTheYear,
                month: window.iTheMonth,
                tagid: window.iTheTagID,
                catid: window.iTheCatID,
                paged: window.iThePaged,
            };

            window.Ajax.do_search (
                oTheParam,
                function (data)
                {
                    window.oTheContainer.addClass('-show-results').append(data.markup);
                    $('.orkla-header').addClass('-search-results-active').removeClass('-search-results-loading');
                    window.oTheSearchForm.addClass('-filter-visible')/*.removeClass('-loading-results')*/;
                    window.oTheTrigger.attr('data-max-num-pages', data.max_num_pages);
                    window.oTheTrigger.attr('data-paged', iThePaged * 1 + 1);
                    window.isLoading = false;
                },
                function (data)
                {
                    // error handlder – necessary???
                    window.isLoading = false
                }
            );
        }
        window.loadPosts = loadPosts;

        $(document).on('change', '.filter.post-tag-filter select', function()
        {
            if ($(this).find('option:selected').attr('data-term-id'))
            {
                window.oTheTrigger.attr('data-tag-id', $(this).find('option:selected').attr('data-term-id'));
            }
            else
            {
                window.oTheTrigger.attr('data-tag-id', '');
            }

            window.oTheTrigger.click();
        });

        $(document).on('change', '.filter.category-filter select', function()
        {

            if ($(this).find('option:selected').attr('data-term-id'))
            {
                window.oTheTrigger.attr('data-cat-id', $(this).find('option:selected').attr('data-term-id'));
            }
            else
            {
                window.oTheTrigger.attr('data-cat-id', '');
            }
            window.oTheTrigger.click();

        });

        $(document).on('change', '.filter.date-filter select', function()
        {
            if ($(this).find('option:selected').attr('data-month') && $(this).find('option:selected').attr('data-year'))
            {
                window.oTheTrigger.attr('data-month', $(this).find('option:selected').attr('data-month'));
                window.oTheTrigger.attr('data-year', $(this).find('option:selected').attr('data-year'));
            }
            else
            {
                window.oTheTrigger.attr('data-month', '');
                window.oTheTrigger.attr('data-year', '');
            }
            window.oTheTrigger.click();

        });

        $(window.oTheSearchForm).on('submit', function (e)
        {
            e.preventDefault();
            window.oTheContainer.removeClass('-show-results').empty();
            $('.orkla-header').addClass('-search-results-loading');
            //window.oTheSearchForm.addClass('-loading-results');
            window.oTheTrigger.attr('data-paged', 1);
            window.loadPosts();
        });

        $(document).on('change', 'select#selectPosCats.-is-ready', function( )
        {
            $(this).removeClass('-is-ready');
            $('.component.vacancies').find('select#selectPosLocs').removeClass('-is-ready');
            window.syncBothSelectors( $(this).find('option:selected'), '#selectPosCats', 'data-category', '#selectPosLocs', 'data-location');
            $(this).addClass('-is-ready');
            $('.component.vacancies').find('select#selectPosLocs').addClass('-is-ready');
            //$('.vacancies-filter').attr('data-preselected', $(this).val());
            vacancyFilterObserver.unobserve($('.vacancies-filter')[0]);
        });

        $(document).on('change', 'select#selectPosLocs.-is-ready', function( )
        {
            $(this).removeClass('-is-ready');
            $('.component.vacancies').find('select#selectPosCats').removeClass('-is-ready');
            window.syncBothSelectors( $(this).find('option:selected'), '#selectPosLocs', 'data-location', '#selectPosCats', 'data-category' );
            $(this).addClass('-is-ready');
            $('.component.vacancies').find('select#selectPosCats').addClass('-is-ready');
        });

        $(document).on('click', '.component.vacancies button.load-more', function( )
        {
            var iTheVacanciesCounter = $('.component.vacancies').attr('data-element-count') * 1 + 1;

            let iTheNext = 1 * $(this).attr('data-next-page');
            let iTheLimit = iTheVacanciesCounter * iTheNext;

            if ($(this).find('i.icon').hasClass('arrow-up'))
            {
                let iTheCounter = $('#vacanciesList').find('a.-is-visible.-is-selected').length;

                let oTheVacancies = $('#vacanciesList').find('a.-is-visible.-is-selected');

                //$(allAccordionElements.get().reverse()).each(function(index) {

                $(oTheVacancies.get().reverse()).each( function ()
                {
                    if ( iTheCounter > iTheVacanciesCounter)
                    {
                        $(this).addClass('-is-hidden').removeClass('-is-visible');
                        iTheCounter --;
                    }
                });

                $(this).attr('data-next-page', iTheNext + 1);
            }
            else
            {
                let iTheCounter = 1;

                $('#vacanciesList').find('a').each( function ()
                {
                    if ( $(this).hasClass('-is-selected') && (iTheCounter <= iTheLimit) )
                    {
                        if ($(this).hasClass('-is-hidden'))
                        {
                            $(this).removeClass('-is-hidden').addClass('-is-visible');
                        }
                        iTheCounter ++;
                    }
                });

                $(this).attr('data-next-page', iTheNext + 1);
            }


            window.checkLoadMoreBtn();
        });


        function syncBothSelectors ( $option, sTheThisID = '#selectPosLocs', sTheThisAttr = 'data-location', sTheOtherID = '#selectPosCats', sTheOtherAttr = 'data-category')
        {
            var iTheVacanciesCounter = $('.component.vacancies').attr('data-element-count') * 1  + 1;

            if ( $option.val() == '0')
            {
                window.resetSelectors();
            }
            else
            {
                let sThePositions = decodeURIComponent( $option.attr('data-positions' ));
                let aThePositions =  JSON.parse( sThePositions );
                let aTheCommonSelected = [];

                $('#vacanciesList a').removeClass('-is-hidden').removeClass('-is-selected').removeClass('-is-visible').addClass('-is-hidden');

                // LOOP thru positions from first select
                $.each(aThePositions, function ()
                {
                    let positionID = $(this)[0];
                    let groupID = $(this)[1];
                    let iTheCurrent = 0;

                    // LOOP thru other select and reset values according to $(this) group IDs
                    $(sTheOtherID).find ('option').each (function ()
                    {
                        let sTheName = $(this).attr('data-name');

                        if (groupID == $(this).val())
                        {
                            let oTheCandidatePosition = $('#vacanciesList').find('a[' + sTheOtherAttr +'="' + $(this).val() + '"][' + sTheThisAttr + '="' + $option.val() + '"]');

                            if ( $(oTheCandidatePosition).length)
                            {
                                iTheCurrent = $(oTheCandidatePosition).length;
                                $(this).text( sTheName + ' (' + iTheCurrent + ')');
                                $(this).attr('data-reset', true);
                                $(this).attr('data-current-count', iTheCurrent);
                                $(this).prop('disabled', false);
                            }
                        }
                        else if ( $(this).attr('data-reset') == 'false')
                        {
                            $(this).text( sTheName + ' (0)');
                            $(this).attr('data-current-count', 0);
                            $(this).attr('data-reset', true);
                            $(this).prop('disabled', true);
                        }
                    });
                });

                let iTheCounter = 0;

                // reset listing based on selections
                $('#vacanciesList').find('a').each (function ()
                {
                    let sTheThisCriterium =  $(sTheThisID).find('option:selected').attr('value');
                    let sTheOtherCriterium =  $(sTheOtherID).find('option:selected').attr('value');

                    if (  $('#selectPosLocs').val() != "0" &&  $('#selectPosCats').val() != "0") // both are selected
                    {
                        if ( $(this).attr(sTheThisAttr) == sTheThisCriterium && $(this).attr(sTheOtherAttr) == sTheOtherCriterium)
                        {
                            $(this).addClass('-is-selected');

                            if (iTheCounter < iTheVacanciesCounter)
                            {
                                $(this).addClass('-is-visible').removeClass('-is-hidden');
                            }
                            iTheCounter ++;
                        }
                    }
                    else // one is selected
                    {
                        if ( $(this).attr(sTheThisAttr) == sTheThisCriterium)
                        {
                            $(this).addClass('-is-selected');
                            if (iTheCounter < iTheVacanciesCounter)
                            {
                                $(this).addClass('-is-visible').removeClass('-is-hidden');
                            }
                            iTheCounter ++;
                        }
                    }
                });

                // make sure available selections reflect selections made

                if (  $('#selectPosLocs').find('option:selected').val() != "0" &&  $('#selectPosCats').find('option:selected').val() != "0") // both are selected
                {
                    $('.vacancies-filter').find('option').each( function()
                    {
                        let sTheName = $(this).attr('data-name');

                        if ( $(this).val() != "0" )
                        {
                            var sTheSelectedValue = $(this).closest('select').find('option:selected').attr('value');

                            if (sTheSelectedValue != $(this).attr('value') )
                            {
                                $(this).text( sTheName + ' (0)');
                                //$(this).attr('data-reset', true);
                                $(this).attr('data-current-count', 0);
                                $(this).prop('disabled', true);
                            }
                        }
                    });
                }

                $('.component.vacancies').find('button.load-more').attr('data-total', iTheCounter);
                $('.component.vacancies').find('button.load-more').attr('data-next-page', 2);
                window.checkLoadMoreBtn();
            }
        }
        window.syncBothSelectors = syncBothSelectors;


        function resetSelectors ()
        {
            var iTheVacanciesCounter = $('.component.vacancies').attr('data-element-count')  * 1 + 1;
            let iTheCounter = 0;
            $('#vacanciesList a').addClass('-is-selected').removeClass('-is-visible').addClass('-is-hidden');

            $('#vacanciesList').find('a').each( function ()
            {
                 if ( iTheCounter < iTheVacanciesCounter )
                 {
                    $(this).removeClass('-is-hidden').addClass('-is-visible');
                    iTheCounter ++;
                 }
             });

            $('.component.vacancies').find('button.load-more').attr('data-total', $('#vacanciesList a').length );

            if ( $('#vacanciesList a').length > iTheVacanciesCounter)
            {
                $('.component.vacancies').find('button.load-more').removeClass('-is-hidden').addClass('-is-visible');
            }

            $('.component.vacancies').find('button.load-more').attr('data-next-page', 2);

            $('.vacancies-filter').find('select').each( function ()
            {
                $(this).find('option:first-child').prop('selected', 'selected');

                $(this).find('option').each( function()
                {
                    if ($(this).val() != '0')
                    {
                        let sTheName = $(this).attr('data-name');
                        let iTheNum = $(this).attr('data-count');
                        $(this).attr('data-current-count', iTheNum);
                        $(this).attr('data-reset', 'false');
                        $(this).text( sTheName + ' (' + iTheNum + ')');
                        $(this).prop('disabled', false);
                    }
                });

            });
            window.checkLoadMoreBtn();
        }

        window.resetSelectors = resetSelectors;

        function checkLoadMoreBtn()
        {
            var iTheVacanciesCounter = $('.component.vacancies').attr('data-element-count')  * 1 + 1;

            if ( $('.-is-selected.-is-hidden').length == 0 && $('.-is-visible').length <= iTheVacanciesCounter)
            {
                $('.component.vacancies').find('button.load-more').addClass('-is-hidden');
            }
            else if ( $('.-is-selected.-is-hidden').length == 0  && $('.-is-visible').length > iTheVacanciesCounter)
            {
                $('.component.vacancies').find('button.load-more').removeClass('-is-hidden');
                $('.component.vacancies').find('button.load-more').find('span').html($('.component.vacancies').find('button.load-more').attr('data-close-label'));
                $('.component.vacancies').find('button.load-more').find('.icon').addClass('arrow-up');
            }
            else
            {
                $('.component.vacancies').find('button.load-more').removeClass('-is-hidden');
                $('.component.vacancies').find('button.load-more').find('span').html($('.component.vacancies').find('button.load-more').attr('data-open-label'));
                $('.component.vacancies').find('button.load-more').find('.icon').removeClass('arrow-up');
            }
        }
        window.checkLoadMoreBtn = checkLoadMoreBtn;

      /* Debug titles on components - position them on top and left of parent container */
      $('.debug-component-title').each(function()
      {
          var offsetLeft = $(this).offset().left - $(this).parent().offset().left;
          var offsetTop = $(this).offset().top - $(this).parent().offset().top;
          $(this).css('margin-top', -offsetTop, 'margin-left', -offsetLeft);
          $(this).css('margin-left', -offsetLeft);
      });


    $('.debug-panel button').on('click', function() {
      $('body').removeClass(function(index, className) {
        return (className.match(/(^|\s)color-theme-\S+/g) || []).join(' ');
      }).addClass($(this).data('class'));
    });

    function repaint(selector) {
      $(selector).addClass('repaint');
      setTimeout(() => {
        $(selector).removeClass('repaint');
      }, 5);
    }

    $( '.component' ).hover(
        function() {
            if ( $( this ).attr('id') &&  $( this ).attr('id') != 'main' && $('body').hasClass('customize-support') )
            {
                console.log('in');
                $('body').append('<div class="id-identifyer">' + $( this ).attr('id') + '</div>');
            };
        }, function() {
            if ( $( this ).attr('id') &&  $( this ).attr('id') != 'main' && $('body').hasClass('customize-support')  &&  $('body').find('.id-identifyer').length > 0 )
            {
                console.log('out');
                //$('body').find('.id-identifyer').remove();
            };
        }
    );


    // possibly chrome specific bugfix: if button is pressed by mouse (as opposed to by a key), remove focus to restore its default state
    $('button').on('click', function(e) {
      let code = e.keyCode || e.which || null;

      if (code !== 13) {
        setTimeout(() => {
          $(this).blur();
        }, 500);
      }
    });

    // Show/hide main menu
    var menuTransitionTiming = 400;
    var menuItemTransitionTiming = 400;
    var staggerTiming = 20;

    function openMainMenu(el) {
      $('body').addClass('-menu-open');
      $('.orkla-header').addClass('-menu-open');
      $('.orkla-header').addClass(el.data('trigger') + '-active');
      el.addClass('is-active');
      el.attr('aria-expanded', true);
      MicroModal.show('mainMenu');

      anime({
        targets: ['.main-menu .menu-item, .main-menu .some-link, .main-menu .language-toggle-item'],
        translateY: ['-2rem', 0],
        opacity: [0.01, 1],
        delay: anime.stagger(staggerTiming, {from: 'last'}),
        easing: 'easeInOutCubic',
        duration: menuItemTransitionTiming,
      });
    }

    function closeMainMenu(el) {
        el.removeClass('is-active');
        el.addClass('-closing');
        $('.orkla-header').addClass('-menu-closing');

        anime({
            targets: ['.main-menu .menu-item, .main-menu .some-link, .main-menu .language-toggle-item'],
            translateY: [0, '-2rem'],
            opacity: [1, 0.01],
            delay: anime.stagger(staggerTiming, {from: 'first'}),
            easing: 'easeInOutCubic',
            duration: menuItemTransitionTiming,
        });

        setTimeout(() => {
            $('body').removeClass('-menu-open');
            $('.orkla-header').removeClass('-menu-open -menu-closing');
            $('.orkla-header').removeClass('-menu-active -search-active');
            $('.orkla-header').removeClass('-search-results-active');
            window.oTheSearchForm.removeClass('-filter-visible');
            window.oTheContainer.removeClass('-show-results').empty();
            window.sTheQuery = $('#headerSearchInput').val('');
            window.iTheTagID = window.oTheTrigger.attr('data-tag-id', '');
            window.iTheCatID = window.oTheTrigger.attr('data-cat-id', '');
            window.iTheMonth = window.oTheTrigger.attr('data-month', '');
            window.iTheYear = window.oTheTrigger.attr('data-year', '');
            window.iThePaged = window.oTheTrigger.attr('data-paged', 1);
            el.removeClass('-closing');
            MicroModal.close('mainMenu');
            el.attr('aria-expanded', false);
            repaint('.orkla-header');
        }, menuTransitionTiming);
    }

    $('.orkla-header .trigger').on('click', function(e) {
      let code = e.keyCode || e.which || null;

      if ($('.orkla-header').hasClass('-menu-open')) {
        closeMainMenu($(this));

        if (code !== 13) {

          setTimeout(() => {
            $('.orkla-header .trigger').blur();
          }, menuTransitionTiming + 25);
        }
      } else {
        openMainMenu($(this));
      }
    });


    $('.orkla-header .-is-parent i').on('click', function(e)
    {
      let currentSubMenu = $(this);

      if (currentSubMenu.hasClass('-is-open'))
      {
        window.subMenu(currentSubMenu, 'close');
      }
      else
      {
        window.subMenu(currentSubMenu, 'open');
      }
    });

    function subMenu (currentSubMenu, action)
    {
      anime({
        targets: ['.-sub-is-active'],
        translateY: [0, '-2rem'],
        opacity: [1, 0.01],
        //height: ['3rem', 0],
        delay: anime.stagger(staggerTiming, {from: 'last'}),
        easing: 'easeInOutCubic',
        duration: menuItemTransitionTiming,
        complete: function()
        {
          $('.-sub-is-active').attr('aria-expanded', false).removeClass('-sub-is-active');
          $('i').removeClass('-is-open').addClass('-is-closed');

          if (action == 'open')
          {
            currentSubMenu.addClass('-is-open').removeClass('-is-closed');
            currentSubMenu.closest('li').find('.sub-menu').addClass('-sub-is-active');
            currentSubMenu.attr('aria-expanded', true);
            anime({
              targets: ['.-sub-is-active'],
              translateY: ['-2rem', 0],
              opacity: [0.01, 1],
              //height:[0, '3rem'],
              delay: anime.stagger(staggerTiming, {from: 'last'}),
              easing: 'easeInOutCubic',
              duration: menuItemTransitionTiming,
            });
          }
        },
      });
    }

    window.subMenu = subMenu;

    var iTheNavbarHeight = 75;
    var navbarThreshold = 10;

    function getNavbarHeight() {
      let sTheHeight = $('body').css('--navbar-height');

      const arr = sTheHeight || [];
      const result1 = arr.length;
      const result2 = arr.length || 0;

      if (result2.length && result2.indexOf('rem') > -1) {
        let result2 = result2.replace('rem', '');
        iTheNavbarHeight = Number(result2) * 10;
      }
    }

    getNavbarHeight();

    $(window).on('resize', function() {
      getNavbarHeight();
    });

    function observeItems(entries) {
      entries.map((entry) => {
        var itemTop = $(entry.target).offset().top;

        if (entry.isIntersecting) {

          $(entry.target).removeClass('-out -below -above').addClass('-in');

          // itemObserver.unobserve(entry.target);

        } else if ((scrollTop + windowHeight) < itemTop) {
          // $(entry.target).removeClass('-in').addClass('-out');
          $(entry.target).removeClass('-above').addClass('-out -below');

        } else if (!$(entry.target).hasClass('hidden') && !$(entry.target).hasClass('-is-hidden')) {
          $(entry.target).removeClass('-below').addClass('-in -above');
        }
      });

    }

    var itemObserver = new IntersectionObserver(observeItems);



    // these are the components we will reveal on scroll.
    // If the reveal animation should affect the block's inner content somehow,
    // a target (css selector) is defined. Otherwise, the block is observed as a whole.
    var aTheRevealItems = [
      { block: '.component.accordion', target: '.accordion-item' },
      { block: '.component.archive', target: '.archive-item' },
      { block: '.component.blog-archive', target: '.archive-item' },
      { block: '.component.brands', target: '.brand-item' },
      { block: '.component.editorial-highlight', target: null },
      // { block: '.component.excerpt', target: '.super-title, .paragraph-text, .component-footer' },
      { block: '.component.expandable', target: null },
      { block: '.component.gauges', target: '.gauge-item' },
      { block: '.component.info-graphics', target: '.title, .excerpt, .graphic-item' },
      { block: '.component.link-listing', target: '.link-item' },
      { block: '.component.navigation-module-cards', target: '.card' },
      // { block: '.component.navigation-module', target: '.column-header, .title, .button' },
      { block: '.component.person-list', target: '.person-item'},
      { block: '.component.quotation', target: '.component-super-title, .paragraph-text'},
      { block: '.component.related-articles', target: '.related-article-item' },
      // { block: '.component.vacancies', target: '.vacancies-item' },
      { block: '.component.story', target: '.story-item' },
    ];

    // prepare the items as necessary for animation, and feed them to the observer
    function setupRevealItems(items) {
      $(items).each(function(index, item) {

        if (item.target) {
          $(item.block).find(item.target).each(function(ind, it) {
            $(it).css('--transition-delay-factor', ind);

            itemObserver.observe($(it)[0], { root: document.body, threshold: 0, rootMargin: '8rem' });
          })
        } else {
          $(item.block).each(function(ind, it) {
            itemObserver.observe($(it)[0], { root: document.body, threshold: 0.3, rootMargin: '30vh' });
          })
        }

      })
    }

    $.each(aTheRevealItems, function(index, obj) {
      setupRevealItems($(obj));
    });



    // vacanties are loaded asynchronously, so let's try to get them when they're ready

    var vacancyFilterObserver;

    var vacancyFilter;

    function resetVacancyFilter(entries)
    {

        if ( selectedCategory != 0 )
        {
            $('#selectPosCats').val( selectedCategory);
            $('#selectPosCats').trigger('change');
        }

    }

    if ($('.component.vacancies').length)
    {
        var selectedCategory = $('.vacancies-filter').attr('data-preselected');
        vacancyFilterObserver = new IntersectionObserver( resetVacancyFilter );
        vacancyFilterObserver.observe($('.vacancies-filter')[0], { root: document.body, threshold: 0, rootMargin: '0rem' });

        vacancyWatch = setInterval(() => {
            if (window.vacanciesUpdated) {
                setupRevealItems({ block: '.component.vacancies', target: '.vacancies-item' });
                clearInterval(vacancyWatch);
            }
        }, 100);
    }

    // cheating to remove errant margin in one or two particular cases
    if ($('.component.excerpt').length && $('.component.anchor').length && !$('.component.alert').length) {
      $('.component.excerpt + .component').addClass('-top-margin-override');
    }

    // video – prevent skip at start

    if ($('.video-placeholder').length > 0)
    {
      $('.video-placeholder').each( function()
      {
        loadVideo( $(this).attr('data-video-src'), $(this).attr('src'), $(this).closest('.video-container'));
        let isVideoPlaying = setInterval(() =>
        {
          if ( $(this).closest('.video-container').find('video').get(0).currentTime > 0.5)
          {
            $(this).closest('.video-container').addClass('-is-loaded');
            clearInterval(isVideoPlaying);
          }
        }, 10);
      });
    }

    function loadVideo(sTheVideoSrc, sThePosterSrc, $this)
    {
        var video = '<video autoplay loop playsinline muted src="' + sTheVideoSrc + '" oncontextmenu="return false;"><source type="video/mp4" src="' + sTheVideoSrc + '">Your browser does not support html5 video</video>'; // setup the video element

        $this.append(video); // insert the video element into its container
        $this.find('video')[0].load(); // load the video (it will autoplay because we've set it as a parameter of the video)

    }


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js